module.exports = __webpack_public_path__ + "img/zhibiao-3.effa6e85.svg";